import { defineComponent as _defineComponent } from 'vue'
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import IconeSVG from '@/common/IconeSVG.vue'
import { calcularDiasParaTransicao } from './contagemDaTransicao'

const CHAVE_FECHADA = 'pontotel:barra-transicao-escalas:2026:fechada'

export default /*@__PURE__*/_defineComponent({
  __name: 'BarraTransicaoDeEscalas',
  emits: ["altura"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const { t } = useI18n()
const emitir = __emit
const barra = ref<HTMLElement | null>(null)
const fechada = ref(false)
const diasRestantes = ref(calcularDiasParaTransicao())
let observador: ResizeObserver | undefined
let temporizador: ReturnType<typeof setInterval> | undefined

function informarAltura() {
  emitir('altura', barra.value?.getBoundingClientRect().height ?? 0)
}

async function fechar() {
  fechada.value = true
  observador?.disconnect()
  clearInterval(temporizador)
  try {
    sessionStorage.setItem(CHAVE_FECHADA, '1')
  } catch {
    // O aviso continua dispensável quando o navegador bloqueia o armazenamento.
  }
  await nextTick()
  informarAltura()
}

onMounted(async () => {
  try {
    fechada.value = sessionStorage.getItem(CHAVE_FECHADA) === '1'
  } catch {
    // Sem armazenamento, mantém o aviso visível.
  }
  await nextTick()
  informarAltura()
  if (fechada.value || !barra.value) return
  observador = new ResizeObserver(informarAltura)
  observador.observe(barra.value)
  temporizador = setInterval(() => {
    diasRestantes.value = calcularDiasParaTransicao()
  }, 60_000)
})

onBeforeUnmount(() => {
  observador?.disconnect()
  clearInterval(temporizador)
})

const __returned__ = { t, emitir, CHAVE_FECHADA, barra, fechada, diasRestantes, get observador() { return observador }, set observador(v) { observador = v }, get temporizador() { return temporizador }, set temporizador(v) { temporizador = v }, informarAltura, fechar, IconeSVG }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})